// extracted by mini-css-extract-plugin
module.exports = {"container":"course-preview_container__27NTz","img":"course-preview_img__3C7--","title":"course-preview_title__2VWfg","active":"course-preview_active__9WNw8"};